let rolePermit = function (privilege) {
  // var privileges = sessionStorage.getItem("privileges");
  var privileges = localStorage.getItem("privileges");
  // console.warn(privileges)
  if (privileges != null) {
    var arr = privileges.split(",");
    return arr.indexOf(privilege) > -1;
  } else {
    return false;
  }
}

export default rolePermit